import React, {Component} from "react";
import Title from "antd/lib/typography/Title";
import {Tabs, Empty, Row, Col} from "antd";
import {CompositionLyrics} from "./CompositionLyrics";
import {CompositionInfo} from "./CompositionInfo";
import {CompositionDescription} from "./CompositionDescription";
import {CompositionTags} from "./CompositionTags";
import {CompositionYoutube} from "./CompositionYoutube";
import {CompositionFiles} from "./CompositionFiles";
import {CompositionScore} from "./CompositionScore";

export const CompositionView = ({
                                    composition,
                                    addLink,
                                    deleteLink,
                                    downloadFile,
                                    openFile,
                                    deleteFile,
                                    addFile,
                                    parts,
                                    file
                                }) => {
    const items = [
        {
            label: 'Tekst',
            key: 'lyrics',
            children: <CompositionLyrics
                lyrics={composition.lyrics}/>
        },
        {
            label: 'Opis',
            key: 'description',
            children: <CompositionDescription
                description={composition.description}/>
        },
        {
            label: 'Youtube',
            key: 'youtube',
            children: <CompositionYoutube
                composition={composition}
                links={composition.links}
                addLink={addLink}
                deleteLink={deleteLink}
            />
        },
        {
            label: 'MusicXML',
            key: 'musicxml',
            children: composition.musicxml ?
                <CompositionScore
                    file={composition.musicxml}/> :
                <Empty description={'Brak danych'}/>
        },
        {
            label: 'Pliki',
            key: 'files',
            children: <CompositionFiles
                composition={composition}
                downloadFile={downloadFile}
                openFile={openFile}
                deleteFile={deleteFile}
                addFile={addFile}
                deleteLink={deleteLink}
                parts={parts}
                files={composition.files}
                file={file}
            />
        }
    ];

    if (composition.id) {
        return <div>
            <Row>
                <Col xs={24} sm={24} md={16}>
                    <Title level={3}>
                        {composition.id}. {composition.title}
                    </Title>
                </Col>
                <Col xs={24} sm={24} md={8} style={{textAlign: 'right'}}>
                    <CompositionTags composition={composition}/>
                </Col>
            </Row>
            {
                composition.subtitle ?
                    <Title level={5} style={{marginTop: '0'}}>
                        {composition.subtitle}
                    </Title> :
                    null
            }
            <CompositionInfo composition={composition}/>
            <Tabs defaultActiveKey="lyrics" tabPosition={"top"} items={items} />
        </div>;
    } else {
        return <Empty description={'Brak danych'}></Empty>;
    }
}
